import { OrganizationType } from '../constants/organizationType';
import { LIST, LIST_BY_CATEGORY, LIST_BY_TAG, LIST_COURSES, LIST_MFO } from '../constants/routes';

export const getRouteByOrganizationTypeAndQuery = (
  organizationType: OrganizationType,
  isReviewTagAliasExists?: boolean,
  productCategory?: boolean,
) => {
  let route = LIST;
  switch (organizationType) {
    case OrganizationType.MFI:
      route = LIST_MFO;
      break;
    case OrganizationType.COURSES:
      route = LIST_COURSES;
      break;
    case OrganizationType.BANK:
      if (productCategory) {
        route = LIST_BY_CATEGORY;
      }
      break;
    default:
      if (isReviewTagAliasExists) {
        route = LIST_BY_TAG;
      }
      break;
  }

  return route;
};
